import { cache } from 'react';
import { logger } from '@tuic/logger';
import { Account } from '../../index';

// @TODO: Implement this if the endpoint becomes available

type GetProfileMyTripsByBookingCodeBusResponse = {
  inboundBusTransfers: Array<unknown>;
  outboundBusTransfers: Array<unknown>;
};

type GetBusInformation = (args: {
  idToken: string;
  bookingCode: string;
  // }) => Promise<Account.GetProfileMyTripsByBookingCodeBusResponse | null>;
}) => Promise<GetProfileMyTripsByBookingCodeBusResponse | null>;

export const getBookingBus: GetBusInformation = async ({
  idToken,
  bookingCode,
}) => {
  // let { data, error } = await Account.getProfileMyTripsByBookingCodeBus({
  //   path: {
  //     bookingCode: bookingCode,
  //   },
  //   auth: idToken,
  // });
  let data: GetProfileMyTripsByBookingCodeBusResponse = {
    inboundBusTransfers: [],
    outboundBusTransfers: [],
  };
  let error = null;

  if (error) {
    logger.error('Could not fetch bus-data.');
    logger.error(error);

    return null;
  }

  return data ?? null;
};

export const memoizedGetBookingBus: GetBusInformation = cache(getBookingBus);
